import React from 'react';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import { getRoundedValue, getPdfSubsetIndex } from '../payElementMappings';
import classnames from 'classnames';
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import AdvancedRow from 'ps-components/AdvancedTable/AdvancedRow';
import AdvancedCell from 'ps-components/AdvancedTable/AdvancedCell';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import './EmployeeData.scss';

class EmployeeData extends React.Component {
  static propTypes = {
    checked: bool,
    data: object,
    onToggle: func,
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    isConfigVisible: bool,
    showJobCodeKey: bool,
    monetaryRounding: number,
    percentRounding: number,
    numericRounding: number,
    isAlternateLayout: bool
  };

  state = {
    columns: [],
    rows: []
  };

  constructor(props) {
    super(props);
    this.getEmployeeRow = this.getEmployeeRow.bind(this);
  }

  componentDidMount() {
    const { data, showJobCodeKey, replacementTokens, isAlternateLayout } = this.props;
    let employeeColumns = data.fields;
    let employeeRows = data.rows;

    if (!showJobCodeKey) {
      const replacementValue = replacementTokens.find(replacement => replacement.token === 'job_code_key_text').value;

      // MPE-5608: Lodash cleanup, findIndex
      const jobCodeKeyIndex = data?.fields?.findIndex(e => e === `default_title.${replacementValue}`);

      employeeColumns = data.fields.filter((column, index) => index !== jobCodeKeyIndex);
      employeeRows = data.rows.map(row => row.filter((datum, index) => index !== jobCodeKeyIndex));
    }

    if (isAlternateLayout) {
      const index = getPdfSubsetIndex(data);
      employeeColumns = employeeColumns.splice(0, index);
      employeeRows = employeeRows.map(row => row.splice(0, index));
    }

    this.setState({
      columns: employeeColumns,
      rows: employeeRows
    });
  }

  getEmployeeRow(employee, empIndex) {
    const { columns, rows } = this.state;
    const { data, monetaryRounding, percentRounding, numericRounding, showJobCodeKey } = this.props;

    const cells = employee.map((cellData, index) => {
      const fieldType = columns[index].field_type_code;
      const cellClass = classnames({
        'pxl-text-xsmall comp-sum-employee-data__table-body-cell': true
      });

      return (
        <AdvancedCell className={cellClass} key={index}>
          {typeof cellData === 'number'
            ? getRoundedValue(cellData, fieldType, monetaryRounding, percentRounding, numericRounding)
            : cellData}
        </AdvancedCell>
      );
    });

    return <AdvancedRow key={`employee-${empIndex}`}>{cells}</AdvancedRow>;
  }

  getTableColumns() {
    const { replacementTokens } = this.props;
    const columns = this.state.columns.map(field => field.default_title);
    return columns;
  }

  getDefaultLayout() {
    return (
      <AdvancedTable
        staticTable={true}
        isBasic={true}
        columnHeaders={this.getTableColumns()}
        rowData={this.state.rows}
        getDataRow={this.getEmployeeRow}
        className="comp-sum-employee-data__table"
        headerClassName="comp-sum-employee-data__table-header-cell"
      />
    );
  }

  render() {
    const { checked, data, onToggle, isConfigVisible } = this.props;
    const hasData = data && data.rowCount > 0;

    return (
      <CompensationSummaryCard
        cardTitle="Employee Data"
        checked={checked}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
        hasData={hasData}
      >
        {hasData ? (
          <div className="comp-sum-employee-data">{this.getDefaultLayout()}</div>
        ) : (
          <div className="comp-sum-card__empty-title">This Job Has No Employee Data</div>
        )}
      </CompensationSummaryCard>
    );
  }
}

export default EmployeeData;
